import { useEffect, useState } from "react";
import { useAtom } from "jotai";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

import { personalData } from "../states/personalData";
import LogoutModal from "./LogoutModal/LogoutModal";
import axios from "../axios";
import FeedbackPopup from "../webpages/feedback";

export default function Navigation() {
  const [activePage, setActivePage] = useState("dashboard");
  const [showMobileNavigation, setShowMobileNavigation] = useState(false);
  const [personalCentralData, setPersonalCentralData] = useAtom(personalData);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

  const handleFeedbackSubmit = (data) => {
    console.log("User feedback:", data);
    axios
      .post("/v1/feedback", {
        ...data,
      })
      .then((response) => {
        console.log("🚀 ~ handleFeedbackSubmit ~ response.data:", response.data);
      })
      .catch((err) => {
        console.error("Error submitting feedback:", err);
      });
  };

  const navigation = useNavigate();

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/update/address-and-course") {
      setActivePage("update-address-and-course");
    }
  }, [location.pathname]);

  return (
    <nav className="full-top-navigation-bar-wrapper">
      <div className="top-bar-mobile-navigation--wrapper">
        <div className="top-bar-profile-notification-btn-wrapper">
          <div>
            <img
              style={{ display: "none" }} // TODO: will show once notifications are implemented
              src="/bell-notification.svg"
              alt="Bell Notification"
              width="20"
              height="20"
            />
          </div>
          <div className="">
            <img
              src="/menu-bar-icon.svg"
              alt="user profile"
              // width="35"
              height="25"
              onClick={() => {
                setShowMobileNavigation(true);
              }}
            />
          </div>
        </div>

        <div className={`top-bar-mobile-navigation ${showMobileNavigation ? "open-mobile-navigation" : ""}`}>
          <div className="top-bar-mobile-navigation-close-btn">
            <div
              style={{ paddingTop: "5px" }}
              onClick={() => {
                setShowMobileNavigation(() => false);
                navigation("/dashboard");
              }}
            >
              <img src="/homeicon.svg" alt="homeicon icon" width="18" height="17" />
            </div>

            <div
              onClick={() => {
                setShowMobileNavigation(() => false);
              }}
            >
              X
            </div>
          </div>

          <div className="top-bar-navigation--titles--container">
            <NavLink
              to="/dashboard"
              className={`${activePage === "dashboard" ? "" : "un"}active-link`}
              onClick={() => {
                setShowMobileNavigation(() => false);
                setActivePage(() => "dashboard");
              }}
            >
              Dashboard
            </NavLink>
            <NavLink
              to="/personal-info"
              className={`${activePage === "personal-info" ? "" : "un"}active-link`}
              onClick={() => {
                setShowMobileNavigation(() => false);
                setActivePage(() => "personal-info");
              }}
            >
              Personal Info
            </NavLink>
            <NavLink
              to="/my-courses"
              className={`${activePage === "my-courses" ? "" : "un"}active-link`}
              onClick={() => {
                setShowMobileNavigation(() => false);
                setActivePage(() => "my-courses");
              }}
            >
              My Course
            </NavLink>
            <NavLink
              to="/attendance"
              className={`${activePage === "attendance" ? "" : "un"}active-link`}
              onClick={() => {
                setShowMobileNavigation(() => false);
                setActivePage(() => "attendance");
              }}
            >
              Attendance
            </NavLink>
            <NavLink
              to="/address"
              className={`${activePage === "address" ? "" : "un"}active-link`}
              onClick={() => {
                setShowMobileNavigation(() => false);
                setActivePage(() => "address");
              }}
            >
              My Address
            </NavLink>
            <NavLink
              to="/my-reports"
              className={`${activePage === "my-reports" ? "" : "un"}active-link`}
              onClick={() => {
                setShowMobileNavigation(() => false);
                setActivePage(() => "my-reports");
              }}
            >
              My Reports
            </NavLink>
            <NavLink
              to="/applied-classes"
              className={`${activePage === "applied-classes" ? "" : "un"}active-link`}
              onClick={() => {
                setShowMobileNavigation(() => false);
                setActivePage(() => "applied-classes");
              }}
            >
              Applied Classes
            </NavLink>
            <NavLink
              to="/bank-details"
              className={`${activePage === "bank-details" ? "" : "un"}active-link`}
              onClick={() => {
                setShowMobileNavigation(() => false);
                setActivePage(() => "bank-details");
              }}
            >
              Bank Details
            </NavLink>
            <NavLink
              to="/subscription"
              className={`${activePage === "subscription" ? "" : "un"}active-link`}
              onClick={() => {
                setShowMobileNavigation(() => false);
                setActivePage(() => "subscription");
              }}
            >
              Subscription
            </NavLink>
            <NavLink
              to="/faqs"
              className={`${activePage === "faqs" ? "" : "un"}active-link`}
              onClick={() => {
                setShowMobileNavigation(() => false);
                setActivePage(() => "faqs");
              }}
            >
              FAQ'S
            </NavLink>
            <NavLink
              to="/support"
              className={`${activePage === "support" ? "" : "un"}active-link`}
              onClick={() => {
                setShowMobileNavigation(() => false);
                setActivePage(() => "support");
              }}
            >
              Support
            </NavLink>
            <span
              className="unactive-link"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setShowMobileNavigation(() => false);
                setShowFeedbackPopup(true);
              }}
            >
              Feedback
            </span>
          </div>
          <div className="top-bar-navigation--logout-btn--wrapper">
            <div
              onClick={() => {
                setShowLogoutModal(true);
              }}
            >
              Logout
            </div>
          </div>
        </div>
      </div>
      <div className="top-bar-navigation--wrapper">
        <div className="top-bar-navigation--titles--container">
          <NavLink
            style={{ display: "none" }}
            to="/dashboard"
            className={`${activePage === "dashboard" ? "" : "un"}active-link`}
            onClick={() => {
              setActivePage(() => "dashboard");
            }}
          >
            Dashboard
          </NavLink>
          <NavLink
            style={{ display: "none" }}
            to="/student"
            className={`${activePage === "student" ? "" : "un"}active-link`}
            onClick={() => {
              setActivePage(() => "student");
            }}
          >
            Student
          </NavLink>
          {/* <NavLink to='/classes' className={`${(activePage==='classes')?'':"un"}active-link`} onClick={()=>{setActivePage(()=>'classes')}}>Classes</NavLink> */}
        </div>

        <div className="top-bar-profile-notification-btn-wrapper">
          <div>
            <img
              style={{ display: "none" }}
              src="/bell-notification.svg"
              alt="Bell Notification"
              width="20"
              height="20"
            />
          </div>
          <div className="navigation-profile-pic-wrapper">
            <NavLink to="/my-profile">
              <img
                src={personalCentralData.profile_pic_link}
                alt="user profile"
                width="35"
              // height="40"
              />
            </NavLink>
          </div>
        </div>
      </div>
      <LogoutModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={() => {
          localStorage.removeItem("homeshiksha-tutor-jwt");
          navigation("/");
          window.location.reload();
        }}
      />
      {showFeedbackPopup && (
        <FeedbackPopup
          onClose={() => setShowFeedbackPopup(false)}
          onSubmit={handleFeedbackSubmit}
          isPaymentFeedback={false}
        />
      )}
    </nav>
  );
}
